<template>
  <div class="product-detail">
    <!-- 商品详情表格 -->
    <table v-if="productDetail">
      <tr>
        <td colspan="2">
          <h2 class="title1" >{{ productDetail.title }}</h2>
        </td>
      </tr>
      <tr>
        <td>编号：</td>
        <td><p style="color: red;">{{ productDetail.id }}</p></td>
      </tr>
      <tr>
        <td>布局：</td>
        <td><p>{{ productDetail.sellPoint }}</p></td>
      </tr>
      <tr>
        <td>价格：</td>
        <td><span>{{ productDetail.price }}</span></td>
      </tr>
      <tr>
        <td>页数：</td>
        <td><p>{{ productDetail.num }}</p></td>
      </tr>
      <tr>
        <td>介绍：</td>
        <td v-html="productDetail.descs"></td>
      </tr>
    </table>
    <div v-else>
      <p>加载中...</p>
    </div>

    <!-- 图片展示 -->
    <div class="text">
     <p v-if="productDetail && productDetail.title">
     {{ productDetail.title }}网页共 <span>{{ productDetail.num }}</span> 个页面,以下是网页运行效果截图 <i>（点击下图可放大查看）</i>
    </p>

    </div>
    <div class="pics">
      <div v-for="(image, index) in parsedImages" :key="index">
        <img class="imgs" v-lazy="image" alt="商品图片" @click="openImageViewer(index)" />
      </div>
    </div>

    <!-- 图片放大模态框 -->
    <div v-if="isImageViewerOpen" class="image-viewer-overlay" @click.self="closeImageViewer"   @touchstart="handleTouchStart"
  @touchmove="handleTouchMove"
  @touchend="handleTouchEnd"
>
      <div class="image-viewer">
        <button class="close-button" @click="closeImageViewer">关闭</button>
        <button class="prev-button" @click="prevImage">&lsaquo;</button>
       <img 
      :src="parsedImages[currentImageIndex]" 
      alt="大图" 
      class="large-image" 
      :style="{ transform: `translateX(${touchDeltaX}px)` }" 
    />
        <button class="next-button" @click="nextImage">&rsaquo;</button>
      </div>
    </div>
    <div class="tips">
      <p>说明：成品源码属于可多次销售的,但是同一个学校只卖一份，所以请一定要备注学校全称，避免重复~成品不提供技术指导和免费修改服务的哈，售出后不支持退换货，拍前请选好自己心仪的网页成品！(需要付费修改或者其他要求请联系我们客服)</p>
    </div>
  </div>
</template>

  <script>
  import { productDetail } from '@/api/product'; 
  export default {
  data() {
    return {
      productDetail: null, // 商品详情数据
      isImageViewerOpen: false, // 是否显示模态框
      currentImageIndex: 0, // 当前大图索引
       touchStartX: 0, // 触摸开始的 X 坐标
    touchDeltaX: 0, // 触摸偏移量，用于跟踪滑动距离
    };
  },
  computed: {
    // 解析图片数组
    parsedImages() {
      if (this.productDetail && this.productDetail.image) {
        try {
          return JSON.parse(this.productDetail.image);
        } catch (e) {
          console.error("图片解析错误:", e);
          return [];
        }
      }
      return [];
    },
  },
  methods: {
// 记录触摸起点
handleTouchStart(event) {
  this.touchStartX = event.touches[0].clientX;
},
// 滑动中更新偏移量
handleTouchMove(event) {
  this.touchDeltaX = event.touches[0].clientX - this.touchStartX;
},
// 结束滑动
handleTouchEnd() {
  const threshold = 50;
  if (Math.abs(this.touchDeltaX) > threshold) {
    if (this.touchDeltaX > 0) {
      this.prevImage();
    } else {
      this.nextImage();
    }
  }
  this.touchDeltaX = 0;
},
    // 打开图片查看器
    openImageViewer(index) {
      this.currentImageIndex = index;
      this.isImageViewerOpen = true;
    },
    // 关闭图片查看器
    closeImageViewer() {
      this.isImageViewerOpen = false;
    },
    // 切换到上一张图片
    prevImage() {
      this.currentImageIndex =
        this.currentImageIndex > 0
          ? this.currentImageIndex - 1
          : this.parsedImages.length - 1;
    },
    // 切换到下一张图片
    nextImage() {
      this.currentImageIndex =
        this.currentImageIndex < this.parsedImages.length - 1
          ? this.currentImageIndex + 1
          : 0;
    },
  },
  async created() {
    const productId = this.$route.params.id;
    try {
      const res = await productDetail(productId);
      if (res && res.status === 200 && res.result) {
        this.productDetail = res.result;
      } else {
        this.$message.error(res && res.msg ? res.msg : "商品详情加载失败");
      }
    } catch (error) {
      console.error("请求商品详情失败", error);
      this.$message.error("请求失败，请稍后重试");
    }
  },
};
  </script>
  
  <style scoped>
  .title1{
text-align: center;
color: #f99551;
  }
  .tips{
    width: 90%;
    margin: 0 auto;
    text-align: left;
    padding-top: 2vw;
    margin-top: 1vw;
    border-top: 1px dotted  #666;
  }
  .tips p{
    font-size: 3vw;
    line-height: 5vw;
    color: #666;
  }

    .pics{
      display: flex;
      gap: 2vw;
      flex-wrap: wrap;
      padding: 2vw 5vw;
    }
    .text p{
      text-align: left;
    }
    .text{
      padding-top: 5vw;
      width: 90%;
      line-height: 5vw;
      margin: 0 auto;
    }
    .text span{
      color: red;
    }
    .text i{
      color: #f78d2b;
    }
  .product-detail {
  text-align: center;
}

.product-detail .imgs {
  height: 20vw;
  width: 20vw;
  object-fit: cover;
  box-shadow: 0 0 8px #666;
  margin: 1vw 0; /* 图片外边距使用vw */
}

table {
  text-align: left;
  margin: 0 auto;
  border-collapse: collapse;
  width: 90%; 
}

td {
  border: 0.2vw solid #f78d2b; /* 边框宽度使用vw */
  padding: 1.5vw 0.8vw; /* 单元格内边距使用vw */
  font-size: 4vw;
}

table td:first-of-type {
  font-weight: bold;
  text-align: right;
  width: 15vw; /* 第一列的宽度使用vw */
}
/* 图片查看器 */
.image-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.image-viewer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-viewer .large-image {
  max-width: 100vw; /* 最大宽度为屏幕宽度 */
  max-height: 100vh; /* 最大高度为屏幕高度 */
  object-fit: contain; /* 保持宽高比例 */
  margin-bottom: 20px;
}
.image-viewer .close-button,
.image-viewer .prev-button,
.image-viewer .next-button {
  position: fixed;
  border: none;
  cursor: pointer;
  color: #fff; /* 按钮文字颜色 */
  z-index: 100;
}

.image-viewer .close-button {
  border-radius: 50%; /* 圆形按钮 */
  top: 10px;
  right: 10px;
  background: linear-gradient(135deg, #f78d2b, #ff5733); /* 渐变背景 */
  padding: 2.5vw; /* 调整为 vw 单位 */
  font-size: 3.5vw; /* 动态调整文字大小 */
  box-shadow: 0 0 8px #666;
}

.image-viewer .prev-button {
  left:0px;
  top: 50%;
  transform: translateY(-50%);
 font-size: 12.5vw; 
  width: 10vw;
 background-color: rgba(0, 0, 0, 0.5); /* 默认背景颜色 */
}

.image-viewer .next-button {
  right: 0px;
  top: 50%;
    font-size: 12.5vw; 
 background-color: rgba(0, 0, 0, 0.5); /* 默认背景颜色 */
  transform: translateY(-50%);
  width: 10vw;
}

  </style>
  